export default function tab() {
  window.addEventListener('DOMContentLoaded', () => {
    const tabGroups = document.querySelectorAll('.ModuleTab');

    tabGroups.forEach((tabGroup) => {
      const tabs = tabGroup.querySelectorAll('[role="tab"]');
      const tabList = tabGroup.querySelector('[role="tablist"]');
      const tabHead = tabGroup.querySelector('.ModuleTab__head');

      // 定数の定義
      const KEY_LEFT = 'ArrowLeft';
      const KEY_RIGHT = 'ArrowRight';

      // 各タブにクリックイベントハンドラーを追加
      tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          changeTabs(e, tabGroup);
          scrollToTab(tab, tabHead);
        });
      });

      // タブヘッドの幅超過チェックと横スクロール機能
      function isOverflowing(element) {
        return element.scrollWidth > element.clientWidth;
      }

      function scrollToTab(tab, container) {
        if (isOverflowing(container)) {
          const tabRect = tab.getBoundingClientRect();
          const containerRect = container.getBoundingClientRect();
          const scrollLeft =
            tabRect.left -
            containerRect.left +
            container.scrollLeft -
            (containerRect.width - tabRect.width) / 2;
          container.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      // タブリスト内でフォーカスできるタブを制御
      let tabFocus = 0;
      tabList.addEventListener('keydown', (e) => {
        if (e.key === KEY_LEFT || e.key === KEY_RIGHT) {
          tabs[tabFocus].setAttribute('tabindex', '-1');
          if (e.key === KEY_LEFT) {
            // 左矢印キー対応
            tabFocus = tabFocus > 0 ? tabFocus - 1 : tabs.length - 1;
          } else if (e.key === KEY_RIGHT) {
            // 右矢印キー対応
            tabFocus = tabFocus < tabs.length - 1 ? tabFocus + 1 : 0;
          }
          tabs[tabFocus].setAttribute('tabindex', '0');
          tabs[tabFocus].focus();
          scrollToTab(tabs[tabFocus], tabHead);

          // フォーカス変更時にタブも切り替え
          changeTabs({ target: tabs[tabFocus] }, tabGroup);
        }
      });
    });
  });

  function changeTabs(e, tabGroup) {
    const target = e.target;
    const panelId = target.getAttribute('aria-controls');
    const parent = target.closest('[role="tablist"]');
    const targetPanel = tabGroup.querySelector(`#${panelId}`);
    const tabPanels = tabGroup.querySelectorAll('[role="tabpanel"]');

    if (!panelId || !targetPanel) {
      console.warn('対応するタブパネルが見つかりません:', target);
      return;
    }

    // タブの選択状態をリセット
    parent.querySelectorAll('[aria-selected="true"]').forEach((tab) => {
      tab.setAttribute('aria-selected', 'false');
    });

    // 現在のタブを選択状態に設定
    target.setAttribute('aria-selected', 'true');

    // すべてのパネルを非表示にする
    tabPanels.forEach((panel) => panel.setAttribute('hidden', 'true'));

    // 選択されたパネルを表示
    targetPanel.removeAttribute('hidden');
  }
}
